import { gsap } from 'gsap'

// How far the wordmark's "berg" half springs up on hover, in SVG user units
// (the logo's viewBox is 200x29).
const BERG_TRAVEL = 8

/** Logo bounce
 *
 * The wordmark is one inline SVG split into `.logo__boeken` and `.logo__berg`.
 * Hovering the link springs the "berg" half up and lets it settle; leaving
 * brings it back down without the bounce, so a quick in-and-out stays tidy.
 *
 * Only wired up on pointers that can hover; elsewhere the logo just sits still.
 * Used by the nav overlay (components/main-nav.js) and the footer
 * (components/logo.js).
 */
export class LogoBounce {
	constructor(element) {
		this.element = element
		this.elBerg = element?.querySelector('.logo__berg')

		this.bndOnEnter = this.onEnter.bind(this)
		this.bndOnLeave = this.onLeave.bind(this)

		this.enabled = Boolean(this.elBerg) && window.matchMedia('(hover: hover)').matches
		if (!this.enabled) return

		this.element.addEventListener('pointerenter', this.bndOnEnter)
		this.element.addEventListener('pointerleave', this.bndOnLeave)
	}

	onEnter() {
		gsap.to(this.elBerg, { y: -BERG_TRAVEL, duration: 0.7, ease: 'elastic.out(1, 0.45)', overwrite: true })
	}

	onLeave() {
		gsap.to(this.elBerg, { y: 0, duration: 0.3, ease: 'power2.inOut', overwrite: true })
	}

	destroy() {
		if (!this.enabled) return

		gsap.killTweensOf(this.elBerg)
		gsap.set(this.elBerg, { clearProps: 'all' })
		this.element.removeEventListener('pointerenter', this.bndOnEnter)
		this.element.removeEventListener('pointerleave', this.bndOnLeave)
	}
}
